export const defaultSelectedDate = () => {
  var fecha = new Date();
  fecha.setDate(fecha.getDate()-30);
  return fecha;

};

export const defaultSelectedDateFrom = () => {
  var fecha = new Date();
  return fecha.getFullYear()+'01';

};

export default {
  ag_grid: {
    selectedTheme: 'ag-theme-balham'
  },
  params: {
    count_months:0,
    year_month_from: defaultSelectedDateFrom(),
    year_month_up: defaultSelectedDate(),
    account_from: null,
    option:1,
    account_up: null,
    months:[],
    description_account_from: null,
    description_account_up: null,
    view_delete_from: null,
    view_delete_up: null,
    filter_text: "",
    filter_tag: "",
  },
  account_comparsion: [],
  loading: {
    module: false
  },
  months:[
    {
      id:'01',
      name:'Enero'
    },
    {
      id:'02',
      name:'Febrero'
    },
    {
      id:'03',
      name:'Marzo'
    },
    {
      id:'04',
      name:'Abril'
    },
    {
      id:'05',
      name:'Mayo'
    },
    {
      id:'06',
      name:'Junio'
    },
    {
      id:'07',
      name:'Julio'
    },
    {
      id:'08',
      name:'Agosto'
    },
    {
      id:'09',
      name:'Septiembre'
    },
    {
      id:'10',
      name:'Octubre'
    },
    {
      id:'11',
      name:'Noviembre'
    },
    {
      id:'12',
      name:'Diciembre'
    },
  ]
};



// WEBPACK FOOTER //
// ./src/modules/account-comparison/state.js